import { render, staticRenderFns } from "./whsFooter.vue?vue&type=template&id=a6651840&scoped=true&"
import script from "./whsFooter.vue?vue&type=script&lang=js&"
export * from "./whsFooter.vue?vue&type=script&lang=js&"
import style0 from "./whsFooter.vue?vue&type=style&index=0&id=a6651840&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6651840",
  null
  
)

export default component.exports